// extracted by mini-css-extract-plugin
export default {"root":"VideoControls_root__86n4i","secondaryBtn":"VideoControls_secondaryBtn__JwYGU","disableCamera":"VideoControls_disableCamera__gjLnf","flashOn":"VideoControls_flashOn__6BTtB"};